import {
  ASCENDING_DESCENDING_COPY,
  LEAST_MOST_PROGRESSED_COPY,
  LOWEST_HIGHEST_COPY,
  OLDEST_NEWEST_COPY,
  SortingDirectionValues,
} from 'models/Sort';

export const TABLE_COLUMNS = [
  'name',
  'nda',
  'fileAccess',
  'chat',
  'notes',
  'stage',
  'lastSeen',
  'company',
  'added',
  'context',
];

export type LeadsTableColumnsKey = typeof TABLE_COLUMNS[number];

export const HEADING_TRANSLATIONS: Partial<
  Record<LeadsTableColumnsKey, string>
> = {
  name: 'name',
  nda: 'nda',
  fileAccess: 'fileAccess',
  chat: 'chat',
  notes: 'notes',
  stage: 'stage',
  lastSeen: 'lastSeen',
  company: 'company',
  added: 'added',
  context: 'context',
  referrer: 'referrer',
  email: 'email',
  phone: 'phone',
};

export const SORTING_VALUES: Partial<Record<LeadsTableColumnsKey, string>> = {
  stage: 'stageIndex',
  name: 'sortName',
  nda: 'ndaIndex',
  chat: 'chatSort',
  lastSeen: 'lastSeen',
  notes: 'notesSort',
  company: 'company',
  referrer: 'referrerSortName',
  added: 'createdAt',
  email: 'email',
  phone: 'phone',
};

export const CUSTOM_COL_SIZES: Partial<Record<LeadsTableColumnsKey, number>> = {
  name: 210,
  chat: 100,
  notes: 80,
  delete: 80,
  nda: 150,
  fileAccess: 400,
  context: 200,
  phone: 180,
  email: 300,
};

export const SUPER_ADMIN_COLUMNS = [
  ...TABLE_COLUMNS,
  'email',
  'phone',
  'referrer',
  'delete',
];

export const REQUIRED_COLUMN = 'name';

export const MULTI_SORT_DIRECTION_COPY: Record<
  string,
  SortingDirectionValues[string]
> = {
  [SORTING_VALUES.stage]: LEAST_MOST_PROGRESSED_COPY,
  [SORTING_VALUES.nda]: LEAST_MOST_PROGRESSED_COPY,
  [SORTING_VALUES.chat]: LOWEST_HIGHEST_COPY,
  [SORTING_VALUES.notes]: LOWEST_HIGHEST_COPY,
  [SORTING_VALUES.lastSeen]: OLDEST_NEWEST_COPY,
  [SORTING_VALUES.added]: OLDEST_NEWEST_COPY,
  [SORTING_VALUES.phone]: ASCENDING_DESCENDING_COPY,
};
